var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCommonIconDebitCardColor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#64B5F6",
    d: "M45 35a4 4 0 01-4 4H7a4 4 0 01-4-4V13a4 4 0 014-4h34a4 4 0 014 4v22z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#37474F",
    d: "M3 14h42v6H3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#E3F2FD",
    d: "M5 22h38v5H5z"
  })));
}

export default SvgCommonIconDebitCardColor;